import "./prsm.c8ddbea5.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2ac4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2ac4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fmvtn", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"participatory-system-mapper\",\"version\":\"3.3.3\",\"description\":\"Participatory System Mapper, browser app for collaboratively creating system maps\",\"keywords\":[\"social network\",\"participatory\",\"stakeholder\",\"policy analysis\"],\"bugs\":{\"email\":\"n.gilbert@surrey.ac.uk\"},\"author\":\"Nigel Gilbert\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/micrology/prsm\"},\"alias\":{\"devlop\":\"devlop/lib/default.js\",\"unist-util-visit-parents/do-not-use-color\":\"unist-util-visit-parents/lib/color.js\",\"three/webgpu\":\"three/build/three.webgpu.js\",\"three/tsl\":\"three/build/three.tsl.js\"},\"targets\":{\"default\":{\"distDir\":\"dist\",\"publicUrl\":\".\"}},\"browserslist\":[\"last 2 Chrome versions\",\"last 2 Firefox versions\",\"last 2 Safari versions\",\"last 2 Edge versions\"],\"parcelIgnore\":[\"/doc/help/\"],\"features\":{\"ai\":true},\"type\":\"module\",\"scripts\":{\"lint\":\"eslint --fix ./js/*.js\",\"pretty\":\"prettier --write ./html/*.html ./*.html ./js/*.js ./css/*.css doc/**/*.{html,css} package.json\",\"build-help\":\"cd doc/help && PRSM_DEPLOY=production npm run build\",\"build-help-locally\":\"cd doc/help && npm run build\",\"build-vis-network\":\"cd vis-network && npm run build\",\"spellcheck\":\"npx cspell './js/*.js' './html/*.html' './css/*.css' 'doc/help/docs/manual/*.mdx'\",\"check\":\"npm run lint && npm run spellcheck &&npm run build-help && npm run pretty\",\"dev\":\"npm run clean && npx parcel watch './html/*.html' --no-hmr\",\"build\":\"rm -rf dist/* && npx parcel build './html/*.html'\",\"jsdoc\":\"npx jsdoc -r -c .jsdoc.json\",\"clean\":\"rm -rf dist/*\",\"build-for-docker\":\"node ./utils/build-for-docker.mjs\",\"rebuild-docker\":\"npm run build-for-docker && docker buildx build -f docker/docker-y-websocket/Dockerfile --platform linux/amd64,linux/arm64 -t micrology/prsm-y-websocket --push . && docker buildx build --platform linux/amd64,linux/arm64 -t micrology/prsm-httpd --push -f docker/docker-httpd/Dockerfile .\",\"deploy\":\"npm run install:all && npm run build-vis-network && npm run build && npm run build-help\",\"analyse\":\"npx parcel build './html/*.html' --detailed-report\",\"install:all\":\"npm i && (cd ./doc/help && npm i) && (cd ./api-server && npm i) && (cd ./vis-network && npm i)  && (cd ./ws-server && npm i)\",\"upgrade:all\":\"npm upgrade && (cd ./doc/help && npm upgrade) && (cd ./api-server && npm upgrade) && (cd ./vis-network && npm upgrade) && (cd ./ws-server && npm upgrade)\",\"start:all-locally\":\"./utils/start-all-locally.sh\",\"stop:all-locally\":\"./utils/stop-all-locally.sh\"},\"license\":\"GPL-3.0-or-later\",\"dependencies\":{\"@aws-sdk/client-bedrock-runtime\":\"^3.965.0\",\"@aws-sdk/client-cognito-identity\":\"^3.965.0\",\"@aws-sdk/client-sts\":\"^3.965.0\",\"@egjs/hammerjs\":\"^2.0.17\",\"@jaames/iro\":\"^5.5.2\",\"@knadh/oat\":\"^0.6.0\",\"@popperjs/core\":\"^2.11.8\",\"3d-force-graph\":\"^1.74.5\",\"bootstrap\":\"^5.3.3\",\"component-emitter\":\"^1.3.0\",\"dompurify\":\"^3.4.2\",\"fabric\":\"^7.2.0\",\"fast-xml-parser\":\"^5.7.0\",\"file-saver\":\"^2.0.5\",\"keycharm\":\"^0.4.0\",\"level\":\"^10.0.0\",\"localforage\":\"^1.10.0\",\"luxon\":\"^3.2.1\",\"lz-string\":\"^1.4.4\",\"markdown-to-quill-delta\":\"^1.0.1\",\"marked\":\"^18.0.3\",\"qrcode\":\"^1.5.4\",\"quill\":\"^2.0.0\",\"quill-delta-to-html\":\"^0.12.1\",\"quill-to-word\":\"^1.3.0\",\"tabulator-tables\":\"^6.3.0\",\"three-spritetext\":\"^1.9.3\",\"uuid\":\"^11.1.1\",\"vis-data\":\"^8.0.0\",\"vis-util\":\"^6.0.0\",\"xlsx\":\"https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz\",\"y-websocket\":\"^3.0.0\",\"yjs\":\"^13.6.27\"},\"devDependencies\":{\"@eslint/js\":\"^10.0.1\",\"buffer\":\"^6.0.3\",\"crypto-browserify\":\"^3.12.1\",\"docdash\":\"^2.0.2\",\"eslint\":\"^10.9.1\",\"eslint-config-prettier\":\"^10.1.8\",\"jsdoc\":\"^4.0.2\",\"microdiff\":\"^1.3.1\",\"neostandard\":\"0.14.0-next.1\",\"os-browserify\":\"^0.3.0\",\"parcel\":\"^2.16.4\",\"parcel-resolver-ignore\":\"^2.2.1\",\"path-browserify\":\"^1.0.1\",\"prettier\":\"^3.4.2\",\"process\":\"^0.11.10\",\"stream-browserify\":\"^3.0.0\",\"stream-http\":\"^3.2.0\"},\"private\":true,\"optionalDependencies\":{\"@parcel/rust-linux-arm64-gnu\":\"^2.16.4\",\"@parcel/watcher-linux-arm64-glibc\":\"^2.6.0\",\"@parcel/watcher-linux-x64-glibc\":\"^2.6.0\",\"@swc/core-linux-arm64-gnu\":\"^1.15.2\",\"lightningcss-linux-arm64-gnu\":\"^1.30.2\"}}");

});


var $1bRYB = parcelRequire("1bRYB");

var $kr501 = parcelRequire("kr501");
(()=>{
    var l = class extends HTMLElement {
        #t = !1;
        connectedCallback() {
            this.#t || (document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", ()=>this.#e(), {
                once: !0
            }) : this.#e());
        }
        #e() {
            this.#t || (this.#t = !0, this.init());
        }
        disconnectedCallback() {
            this.cleanup();
        }
        cleanup() {}
        handleEvent(t) {
            let e = this[`on${t.type}`];
            e && e.call(this, t);
        }
        keyNav(t, e, n, o, s, a = !1) {
            let { key: r } = t, c = -1;
            return r === s ? c = (e + 1) % n : r === o ? c = (e - 1 + n) % n : a && (r === "Home" ? c = 0 : r === "End" && (c = n - 1)), c >= 0 && t.preventDefault(), c;
        }
        emit(t, e = null) {
            return this.dispatchEvent(new CustomEvent(t, {
                bubbles: !0,
                composed: !0,
                cancelable: !0,
                detail: e
            }));
        }
        $(t) {
            return this.querySelector(t);
        }
        $$(t) {
            return Array.from(this.querySelectorAll(t));
        }
        uid() {
            return Math.random().toString(36).slice(2, 10);
        }
    };
    "commandForElement" in HTMLButtonElement.prototype || document.addEventListener("click", (i)=>{
        let t = i.target.closest("button[commandfor]");
        if (!t) return;
        let e = document.getElementById(t.getAttribute("commandfor"));
        if (!e) return;
        let n = t.getAttribute("command") || "toggle";
        e instanceof HTMLDialogElement && (n === "show-modal" ? e.showModal() : n === "close" || e.open ? e.close() : e.showModal());
    });
    document.addEventListener("touchstart", (i)=>{
        i.target instanceof HTMLDialogElement && (i.preventDefault(), i.target.close());
    }, {
        passive: !1
    });
    var u = class extends l {
        #t = [];
        #e = [];
        init() {
            let t = this.$(':scope > [role="tablist"]');
            if (this.#t = t ? [
                ...t.querySelectorAll('[role="tab"]')
            ] : [], this.#e = this.$$(':scope > [role="tabpanel"]'), this.#t.length === 0 || this.#e.length === 0) {
                console.warn("ot-tabs: Missing tab or tabpanel elements");
                return;
            }
            this.#t.forEach((n, o)=>{
                let s = this.#e[o];
                if (!s) return;
                let a = n.id || `ot-tab-${this.uid()}`, r = s.id || `ot-panel-${this.uid()}`;
                n.id = a, s.id = r, n.setAttribute("aria-controls", r), s.setAttribute("aria-labelledby", a);
            }), t.addEventListener("click", this), t.addEventListener("keydown", this);
            let e = this.#t.findIndex((n)=>n.ariaSelected === "true");
            this.#i(e >= 0 ? e : 0);
        }
        onclick(t) {
            let e = this.#t.indexOf(t.target.closest('[role="tab"]'));
            e >= 0 && this.#i(e);
        }
        onkeydown(t) {
            if (!t.target.closest('[role="tab"]')) return;
            let e = this.keyNav(t, this.activeIndex, this.#t.length, "ArrowLeft", "ArrowRight");
            e >= 0 && (this.#i(e), this.#t[e].focus());
        }
        #i(t) {
            this.#t.forEach((e, n)=>{
                let o = n === t;
                e.ariaSelected = String(o), e.tabIndex = o ? 0 : -1;
            }), this.#e.forEach((e, n)=>{
                e.hidden = n !== t;
            }), this.emit("ot-tab-change", {
                index: t,
                tab: this.#t[t]
            });
        }
        get activeIndex() {
            return this.#t.findIndex((t)=>t.ariaSelected === "true");
        }
        set activeIndex(t) {
            t >= 0 && t < this.#t.length && this.#i(t);
        }
    };
    customElements.define("ot-tabs", u);
    var h = class extends l {
        #t;
        #e;
        #i;
        #n;
        init() {
            this.#t = this.$("[popover]"), this.#e = this.$("[popovertarget]"), !(!this.#t || !this.#e) && (this.#t.addEventListener("toggle", this), this.#t.addEventListener("keydown", this), this.#i = ()=>{
                let t = this.#e.getBoundingClientRect(), e = this.#t.getBoundingClientRect();
                this.#t.style.top = `${t.bottom + e.height > window.innerHeight ? t.top - e.height : t.bottom}px`, this.#t.style.left = `${t.left + e.width > window.innerWidth ? t.right - e.width : t.left}px`;
            });
        }
        ontoggle(t) {
            t.newState === "open" ? (this.#i(), window.addEventListener("scroll", this.#i, !0), window.addEventListener("resize", this.#i), this.#n = this.$$('[role="menuitem"]'), this.#n[0]?.focus(), this.#e.ariaExpanded = "true") : (this.cleanup(), this.#n = null, this.#e.ariaExpanded = "false", this.#e.focus());
        }
        onkeydown(t) {
            if (!t.target.matches('[role="menuitem"]')) return;
            let e = this.#n.indexOf(t.target), n = this.keyNav(t, e, this.#n.length, "ArrowUp", "ArrowDown", !0);
            n >= 0 && this.#n[n].focus();
        }
        cleanup() {
            window.removeEventListener("scroll", this.#i, !0), window.removeEventListener("resize", this.#i);
        }
    };
    customElements.define("ot-dropdown", h);
    document.addEventListener("DOMContentLoaded", ()=>{
        let i = "title", t = "[title]", e = (n)=>{
            let o = n.getAttribute(i);
            o && (n.setAttribute("data-tooltip", o), n.hasAttribute("aria-label") || n.setAttribute("aria-label", o), n.removeAttribute(i));
        };
        document.querySelectorAll(t).forEach(e), new MutationObserver((n)=>{
            for (let o of n){
                e(o.target);
                for (let s of o.addedNodes)s.nodeType === 1 && (e(s), s.querySelectorAll(t).forEach(e));
            }
        }).observe(document.body, {
            childList: !0,
            subtree: !0,
            attributes: !0,
            attributeFilter: [
                i
            ]
        });
    });
    document.addEventListener("click", (i)=>{
        let t = i.target.closest("[data-sidebar-toggle]");
        if (t) {
            t.closest("[data-sidebar-layout]")?.toggleAttribute("data-sidebar-open");
            return;
        }
        if (!i.target.closest("[data-sidebar]")) {
            let e = document.querySelector("[data-sidebar-layout][data-sidebar-open]");
            e && window.matchMedia("(max-width: 768px)").matches && e.removeAttribute("data-sidebar-open");
        }
    });
    var d = {};
    function E(i) {
        if (!d[i]) {
            let t = document.createElement("div");
            t.className = "toast-container", t.setAttribute("popover", "manual"), t.setAttribute("data-placement", i), document.body.appendChild(t), d[i] = t;
        }
        return d[i];
    }
    function p(i, t = {}) {
        let { placement: e = "top-right", duration: n = 4e3 } = t, o = E(e);
        i.classList.add("toast");
        let s;
        return i.onmouseenter = ()=>clearTimeout(s), i.onmouseleave = ()=>{
            n > 0 && (s = setTimeout(()=>f(i, o), n));
        }, i.setAttribute("data-entering", ""), o.appendChild(i), o.showPopover(), requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                i.removeAttribute("data-entering");
            });
        }), n > 0 && (s = setTimeout(()=>f(i, o), n)), i;
    }
    function f(i, t) {
        if (i.hasAttribute("data-exiting")) return;
        i.setAttribute("data-exiting", "");
        let e = ()=>{
            i.remove(), t.children.length || t.hidePopover();
        };
        i.addEventListener("transitionend", e, {
            once: !0
        });
        let n = getComputedStyle(i).getPropertyValue("--transition").trim(), o = parseFloat(n), s = n.endsWith("ms") ? o : o * 1e3;
        setTimeout(e, s);
    }
    function g(i, t, e = {}) {
        let { variant: n = "info", ...o } = e, s = document.createElement("output");
        if (s.setAttribute("data-variant", n), t) {
            let r = document.createElement("h6");
            r.className = "toast-title", r.textContent = t, s.appendChild(r);
        }
        let a = document.createElement("div");
        return a.className = "toast-message", a.textContent = i, s.appendChild(a), p(s, o);
    }
    function b(i, t = {}) {
        let e;
        if (i instanceof HTMLTemplateElement ? e = i.content.firstElementChild?.cloneNode(!0) : i && (e = i.cloneNode(!0)), !!e) return e.removeAttribute("id"), p(e, t);
    }
    function v(i) {
        i && d[i] ? (d[i].innerHTML = "", d[i].hidePopover()) : Object.values(d).forEach((t)=>{
            t.innerHTML = "", t.hidePopover();
        });
    }
    var m = window.ot || (window.ot = {});
    m.toast = g;
    m.toast.el = b;
    m.toast.clear = v;
})();



var $fmvtn = parcelRequire("fmvtn");
document.addEventListener('DOMContentLoaded', ()=>{
    // Docker / no-API builds: keep AI marketing copy, hide the live chatbot widget
    if (!(0, $fmvtn.features).ai) {
        const chatbotHelp = document.getElementById('chatbothelp');
        if (chatbotHelp) chatbotHelp.style.display = 'none';
        document.querySelectorAll('a[href="#chatbothelp"]').forEach((link)=>{
            link.style.display = 'none';
        });
    }
    const overlay = document.getElementById('processing-overlay');
    const sendBtn = document.getElementById('send-btn');
    const copyChat = document.getElementById('copy-chat');
    const newChat = document.getElementById('new-chat');
    const userInput = document.getElementById('user-input');
    const messagesDiv = document.getElementById('chat-messages');
    let chatHistory = [];
    // configure image path for markdown-rendered images (e.g. from help assistant)
    const isLocal = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
    const IMAGE_BASE_URL = isLocal ? 'http://127.0.0.1/prsm/doc/help/doc_build' : 'https://prsm.uk/doc/help/doc_build';
    const API_BASE_URL = isLocal ? 'http://localhost:3001' : 'https://prsm.uk';
    async function sendMessage(prompt = '') {
        const message = prompt || userInput.value.trim();
        if (!message) return;
        // Add User Message to UI and chat history
        chatHistory.push({
            role: 'user',
            content: [
                {
                    text: message
                }
            ]
        });
        appendMessage('user', message);
        userInput.value = '';
        overlay.style.display = 'block';
        try {
            const response = await fetch(`${API_BASE_URL}/api/helpAssistant`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    messages: chatHistory
                })
            });
            const data = await response.json();
            overlay.style.display = 'none';
            if (data.error) throw new Error(data.error);
            // Add AI response to history
            chatHistory.push({
                role: 'assistant',
                content: [
                    {
                        text: data.response
                    }
                ]
            });
            // Render the AI response as Markdown
            appendMessage('ai', data.response, data.sources);
        } catch (err) {
            overlay.style.display = 'none';
            appendMessage('ai', `**Error:** ${err.message}`);
        }
    }
    function appendMessage(sender, text, sources = []) {
        const msgDiv = document.createElement('div');
        msgDiv.className = `message ${sender}-message`;
        // 1. Convert Markdown text to HTML
        const renderer = new (0, $1bRYB.marked).Renderer();
        renderer.image = function(token) {
            let finalHref = token.href;
            // If the path is relative (starts with /images/), prepend the base URL
            if (token.href && token.href.startsWith('/images/')) finalHref = `${IMAGE_BASE_URL}${token.href}`;
            return `<img src="${finalHref}" alt="${token.text || ''}" title="${token.title || ''}" class="chat-image" />`;
        };
        (0, $1bRYB.marked).use({
            renderer: renderer
        });
        let htmlContent = (0, $1bRYB.marked).parse(text);
        // 2. Append research sources only (manual answers intentionally have none)
        const citableSources = (sources || []).filter((source)=>source && typeof source.url === 'string' && /^https?:\/\//i.test(source.url.trim()));
        if (citableSources.length > 0) {
            htmlContent += `<div class="source-header">Sources:</div>`;
            citableSources.forEach((source)=>{
                htmlContent += `<a href="${source.url.trim()}" target="_blank" class="source-link">\u{1F4D6} ${source.name || 'Research Source'}</a>`;
            });
        }
        const ALLOWED_ATTR = [
            'href',
            'src',
            'alt',
            'title',
            'class',
            'target'
        ];
        msgDiv.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($kr501))).sanitize(htmlContent, {
            ALLOWED_ATTR: ALLOWED_ATTR
        });
        // Remove any previous spacer
        const oldSpacer = messagesDiv.querySelector('.chat-spacer');
        if (oldSpacer) oldSpacer.remove();
        messagesDiv.appendChild(msgDiv);
        if (sender === 'user') {
            // Add a spacer so there is always enough overflow to scroll
            // the user message to the very top of the visible area
            const spacer = document.createElement('div');
            spacer.className = 'chat-spacer';
            spacer.style.height = messagesDiv.clientHeight + 'px';
            messagesDiv.appendChild(spacer);
            const pageY = window.scrollY;
            msgDiv.scrollIntoView({
                block: 'start'
            });
            window.scrollTo(0, pageY);
        }
    }
    // Event listeners
    sendBtn.addEventListener('click', ()=>sendMessage());
    userInput.addEventListener('keypress', (e)=>{
        if (e.key === 'Enter') sendMessage();
    });
    copyChat.addEventListener('click', ()=>copyChatWindowToClipboard());
    newChat.addEventListener('click', ()=>{
        chatHistory = [];
        messagesDiv.innerHTML = '';
    });
    // Select all the suggestion buttons and add the listener
    document.querySelectorAll('.chat-suggestion').forEach((button)=>{
        button.addEventListener('click', ()=>{
            sendMessage(button.textContent.trim());
        });
    });
    // Hamburger menu toggle
    const hamburger = document.getElementById('hamburger');
    const navButtons = document.querySelector('.nav-buttons');
    hamburger.addEventListener('click', ()=>{
        navButtons.classList.toggle('mobile-open');
        const expanded = navButtons.classList.contains('mobile-open');
        hamburger.setAttribute('aria-expanded', expanded);
    });
    // Close menu when a nav item is clicked
    document.querySelectorAll('.nav-menu a, .nav-menu button').forEach((item)=>{
        item.addEventListener('click', ()=>{
            navButtons.classList.remove('mobile-open');
            hamburger.setAttribute('aria-expanded', false);
        });
    });
    function copyChatWindowToClipboard() {
        const chatContent = messagesDiv.innerText;
        navigator.clipboard.writeText(chatContent).then(()=>window.ot.toast('Chat copied to clipboard', '', {
                variant: 'success',
                duration: 3000,
                placement: 'top-center'
            }), (err)=>window.ot.toast(`Failed to copy chat: ${err}`, '', {
                variant: 'error',
                duration: 5000,
                placement: 'top-center'
            }));
    }
    // cookie policy
    window.addEventListener('load', ()=>{
        const cookieOverlay = document.querySelector('.cookie-overlay');
        cookieOverlay.style.display = document.cookie.indexOf('accepted_cookies=') < 0 ? 'grid' : 'none';
        const acceptCookies = document.getElementById('accept-cookies');
        acceptCookies.addEventListener('click', function() {
            document.cookie = 'accepted_cookies=yes;';
            cookieOverlay.style.display = 'none';
        });
        const closeCookies = document.getElementById('close-cookies');
        closeCookies.addEventListener('click', function() {
            cookieOverlay.style.display = 'none';
        });
    });
    // Show popup after 10 seconds
    setTimeout(()=>{
        document.getElementById('mc_embed_signup').style.visibility = 'visible';
    }, 10000);
    // Close button event
    document.getElementById('closeBtn').onclick = function() {
        document.getElementById('mc_embed_shell').style.display = 'none';
    };
});


//# sourceMappingURL=html.ab6c3da1.js.map
